define(['jquery', 'jquery.transit', 'modernizr', 'container', 'router', 'load-more', 'lightbox', 'preloader'],
    function ($, transit, modernizr, container, router, loadMoreFactory, lightboxFactory, preloader) {

        return (function () {

            const name = 'news';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            const loadMore = loadMoreFactory.create();
            const lightbox = lightboxFactory.create();
            //const pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {};

            /* view */

            view.publicVars = {
            };

            view.privateVars = {
                category: {
                    current: null
                },

                itemsAllCount: 0,

                itemCurrent: {
                    id: null,
                    width: null,
                    height: null,
                },

                itemSize: {
                    width: 900,
                    height: 537
                },

                lightboxAnim: 0,

                lightboxTouchStart: 0,
                lightboxTouchDiff: 0,
                lightboxTouchStartY: 0,
                lightboxTouchDiffY: 0,

                lightboxSlideStarted: false,
                lightboxEndTrans: false,
            };

            view.startup = function () {
                view.privateVars.category.current = view.publicVars.category.current;

                view.privateVars.itemsAllCount = $(view.publicVars.cssId.moduleNewsCategory2ItemFakeCls).length;

                preloader.setPreloadBulk(name, view.publicVars.preloadImgTab);

                loadMore.init(view.publicVars.loadMoreSetup);
                loadMore.setAdditionalParamCallback(view.methods.getCurrentCategory);

                lightbox.setCloseCallback(function () {
                    view.privateVars.itemCurrent = {
                        id: null,
                        width: null,
                        height: null
                    };
                });
            };

            view.bind = function () {
                $(view.publicVars.cssId.moduleNewsBoxesCategory2RowCls).on('click', view.publicVars.cssId.moduleNewsBoxPhotoItemCls, function () {
                    view.privateVars.lightboxAnim = 1;
                    view.methods.showLightbox(this);
                });

                $(window).resize(() => {
                    if (lightbox.getStatus() === 1) {
                        view.methods.calculateLightboxSize(view.privateVars.itemCurrent.width, view.privateVars.itemCurrent.height);
                    }
                });

                $(window).on('orientationchange', () => {
                    if (lightbox.getStatus() === 1) {
                        view.methods.calculateLightboxSize(view.privateVars.itemCurrent.width, view.privateVars.itemCurrent.height);
                    }
                });

                $(view.publicVars.cssId.moduleNewsPhotoLightboxArrowLeftId).click(function () {
                    const newId = (view.privateVars.itemCurrent.id > 1) ? (view.privateVars.itemCurrent.id - 1) : view.privateVars.itemsAllCount;

                    if(!view.privateVars.lightboxAnim) {
                        view.privateVars.lightboxAnim = 1;
                        view.methods.showGalleryForId(newId);
                    }
                });

                $(view.publicVars.cssId.moduleNewsPhotoLightboxArrowRightId).click(function () {
                    const newId = (view.privateVars.itemCurrent.id < view.privateVars.itemsAllCount) ? (view.privateVars.itemCurrent.id + 1) : 1;

                    if(!view.privateVars.lightboxAnim) {
                        view.privateVars.lightboxAnim = 1;
                        view.methods.showGalleryForId(newId);
                    }
                });

                $(view.publicVars.cssId.moduleNewsPhotoLightboxInnerId).bind('touchstart', function(e) {
                    //e.preventDefault();
                    const touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                    return view.methods.slideMouseDown(touch);
                });

                $(view.publicVars.cssId.moduleNewsPhotoLightboxInnerId).bind('touchmove', function(e) {
                    /*if (Math.abs(privateVars.touchDiff) >= Math.abs(privateVars.touchDiffY)) {
                     e.preventDefault();
                     }*/
                    const touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                    return view.methods.slideMouseMove(touch, e);
                });

                $(view.publicVars.cssId.moduleNewsPhotoLightboxInnerId).bind('touchend', function(e) {
                    //e.preventDefault();
                    const touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                    return view.methods.slideMouseUp(touch);
                });
            };

            view.methods = {

                slideMouseDown: function(e) {

                    if (!view.privateVars.lightboxSlideStarted && view.privateVars.lightboxAnim === 0)
                    {
                        view.privateVars.lightboxTouchStart = e.pageX;
                        view.privateVars.lightboxTouchStartY = e.pageY;

                        view.privateVars.lightboxSlideStarted = true;
                    }

                    //return false;

                },

                slideMouseMove: function(e, ev) {

                    if (view.privateVars.lightboxSlideStarted && !view.privateVars.lightboxEndTrans && view.privateVars.lightboxAnim === 0)
                    {
                        view.privateVars.lightboxTouchDiff = view.privateVars.lightboxTouchStart - e.pageX;
                        view.privateVars.lightboxTouchDiffY = view.privateVars.lightboxTouchStartY - e.pageY;

                        if (view.privateVars.lightboxTouchDiff < -40) {
                            view.privateVars.lightboxAnim = 1;
                            const newId = (view.privateVars.itemCurrent.id > 1) ? (view.privateVars.itemCurrent.id - 1) : view.privateVars.itemsAllCount;
                            view.methods.showGalleryForId(newId);
                        } else if (view.privateVars.lightboxTouchDiff > 40) {
                            view.privateVars.lightboxAnim = 1;
                            const newId = (view.privateVars.itemCurrent.id < view.privateVars.itemsAllCount) ? (view.privateVars.itemCurrent.id + 1) : 1;
                            view.methods.showGalleryForId(newId);
                        }

                        if (Math.abs(view.privateVars.lightboxTouchDiff) >= Math.abs(view.privateVars.lightboxTouchDiffY)) {
                            ev.preventDefault();
                        }
                    }

                    //return false;
                },

                slideMouseUp: function(e) {

                    if (view.privateVars.lightboxSlideStarted && view.privateVars.lightboxAnim === 0)
                    {
                        view.privateVars.lightboxEndTrans = true;
                        if (view.privateVars.lightboxTouchDiff < -40) {
                            view.privateVars.lightboxAnim = 1;
                            const newId = (view.privateVars.itemCurrent.id > 1) ? (view.privateVars.itemCurrent.id - 1) : view.privateVars.itemsAllCount;
                            view.methods.showGalleryForId(newId);
                        } else if (view.privateVars.lightboxTouchDiff > 40) {
                            view.privateVars.lightboxAnim = 1;
                            const newId = (view.privateVars.itemCurrent.id < view.privateVars.itemsAllCount) ? (view.privateVars.itemCurrent.id + 1) : 1;
                            view.methods.showGalleryForId(newId);
                        } else {

                            view.privateVars.lightboxTouchDiff = 0;
                            view.privateVars.lightboxTouchStart = 0;

                            view.privateVars.lightboxTouchDiffY = 0;
                            view.privateVars.lightboxTouchStartY = 0;

                            view.privateVars.lightboxSlideStarted = false;
                            view.privateVars.lightboxEndTrans = false;
                        }
                    } else {

                        view.privateVars.lightboxSlideStarted = false;
                        view.privateVars.lightboxEndTrans = false;
                    }
                },

                getCurrentCategory: function () {
                    return view.privateVars.category.current;
                },

                showLightbox: function (handler) {
                    const id = parseInt(container.getData($(handler)[0], 'id'));
                    const bigImg = container.getData($(handler)[0], 'img.big');
                    const width = container.getData($(handler)[0], 'width');
                    const height = container.getData($(handler)[0], 'height');

                    const lightboxSize = view.methods.calculateLightboxSize(width, height);

                    view.privateVars.itemCurrent = {
                        id: id,
                        width: width,
                        height: height
                    };

                    $(view.publicVars.cssId.moduleNewsPhotoLightboxLoaderWrapperId).css({ display: 'block', opacity: 0, scale: 0, rotate: '0deg'})

                    $(view.publicVars.cssId.moduleNewsPhotoLightboxInnerAreaImgId).css({ display: 'block', opacity: 0, scale: 0.5});
                    $(view.publicVars.cssId.moduleNewsPhotoLightboxInnerAreaImgId).attr('src', bigImg);

                    lightbox.showLayer(function () {
                        $(view.publicVars.cssId.moduleNewsPhotoLightboxLoaderWrapperId).transit({ opacity: 1, scale: 1, rotate: '360deg'}, 300, function () {

                            preloader.preloadSingleImage(name + id, bigImg, function () {

                                setTimeout(function () {
                                    $(view.publicVars.cssId.moduleNewsPhotoLightboxInnerAreaImgId).transit({ opacity: 1, scale: 1}, 300, function () {
                                        view.privateVars.lightboxAnim = 0;
                                    });
                                }, 500);

                            });

                        })
                    });

                },

                showGalleryForId: (newId) => {
                    const id = parseInt(container.getData($('#' + view.publicVars.cssId.moduleNewsCategory2ItemFakeCls.substr(1) + newId)[0], 'id'));
                    const bigImg = container.getData($('#' + view.publicVars.cssId.moduleNewsCategory2ItemFakeCls.substr(1) + newId)[0], 'img.big');
                    const width = parseInt(container.getData($('#' + view.publicVars.cssId.moduleNewsCategory2ItemFakeCls.substr(1) + newId)[0], 'width'));
                    const height = parseInt(container.getData($('#' + view.publicVars.cssId.moduleNewsCategory2ItemFakeCls.substr(1) + newId)[0], 'height'));

                    const lightboxSize = view.methods.calculateLightboxSize(width, height);

                    view.privateVars.itemCurrent = {
                        id: id,
                        width: width,
                        height: height
                    };

                    $(view.publicVars.cssId.moduleNewsPhotoLightboxInnerAreaImgId).transit({ opacity: 0, scale: 0.5}, 300, function () {
                        preloader.preloadSingleImage(name + id, bigImg, function () {
                            $(view.publicVars.cssId.moduleNewsPhotoLightboxInnerAreaImgId).css({ display: 'block', opacity: 0, scale: 0.5});
                            $(view.publicVars.cssId.moduleNewsPhotoLightboxInnerAreaImgId).attr('src', bigImg);

                            setTimeout(function () {
                                $(view.publicVars.cssId.moduleNewsPhotoLightboxInnerAreaImgId).transit({ opacity: 1, scale: 1}, 300, function () {
                                    view.privateVars.lightboxAnim = 0;
                                });
                            }, 500);
                        });
                    });
                },

                calculateLightboxSize: (width, height) => {

                    const windowWidth = $(window).width();
                    const windowHeight = $(window).height();

                    const paddingTop = parseInt($(view.publicVars.cssId.moduleNewsPhotoLightboxAreaId).css('padding-top'));
                    const paddingBottom = parseInt($(view.publicVars.cssId.moduleNewsPhotoLightboxAreaId).css('padding-bottom'));
                    const paddingLeft = parseInt($(view.publicVars.cssId.moduleNewsPhotoLightboxAreaId).css('padding-left'));
                    const paddingRight = parseInt($(view.publicVars.cssId.moduleNewsPhotoLightboxAreaId).css('padding-right'));

                    const paddingTopInner = parseInt($(view.publicVars.cssId.moduleNewsPhotoLightboxInnerId).css('padding-top'));
                    const paddingBottomInner = parseInt($(view.publicVars.cssId.moduleNewsPhotoLightboxInnerId).css('padding-bottom'));
                    const paddingLeftInner = parseInt($(view.publicVars.cssId.moduleNewsPhotoLightboxInnerId).css('padding-left'));
                    const paddingRightInner = parseInt($(view.publicVars.cssId.moduleNewsPhotoLightboxInnerId).css('padding-right'));

                    const arrowWidthLeft = parseInt($(view.publicVars.cssId.moduleNewsPhotoLightboxArrowLeftFakeId).css('width'));
                    const arrowWidthRight = parseInt($(view.publicVars.cssId.moduleNewsPhotoLightboxArrowRightFakeId).css('width'));

                    const topModifier = (- parseInt($(view.publicVars.cssId.moduleNewsPhotoLightboxCloseId).css('top'))) * 2;
                    const rightModifier = (- parseInt($(view.publicVars.cssId.moduleNewsPhotoLightboxCloseId).css('right'))) * 2;

                    const maxWidth = windowWidth - paddingLeft - paddingRight - paddingLeftInner - paddingRightInner - arrowWidthLeft - arrowWidthRight;
                    const maxHeight = windowHeight - paddingTop - paddingBottom - paddingTopInner - paddingBottomInner - topModifier;

                    // const maxWidth = windowWidth;
                    // const maxHeight = windowHeight;

                    let lightboxSize;

                    let adjustedWidth = view.privateVars.itemSize.width;
                    let adjustedHeight = view.privateVars.itemSize.height;

                    if (width !== '' && height !== '' && parseInt(width) >= 400 && parseInt(height) >= 400) {
                        adjustedWidth = parseInt(width);
                        adjustedHeight = parseInt(height);
                    }

                    //adjustedWidth = adjustedWidth + paddingLeft + paddingRight;
                    //adjustedHeight = adjustedHeight + paddingTop + paddingBottom;

                    lightboxSize = view.methods.calculateSizeProportionForMaxValues(maxWidth, maxHeight,
                        adjustedWidth, adjustedHeight);

                    const newWidth = lightboxSize.width + paddingLeft + paddingRight + paddingLeftInner + paddingRightInner;
                    const newHeight = lightboxSize.height + paddingTop + paddingBottom + paddingTopInner + paddingBottomInner;

                    $(view.publicVars.cssId.moduleNewsPhotoLightboxAreaId)
                        .css({width: newWidth + 'px', height: newHeight + 'px'});

                },

                calculateSizeProportionForMaxValues: (maxWidth, maxHeight, width, height) => {

                    if (width <= maxWidth && height <= maxHeight) {
                        return {width: width, height: height};
                    }

                    const widthHeightRatio = width / height;
                    const heightWidthRatio = height / width;

                    if (width > maxWidth) {

                        const widthDiff = width - maxWidth;
                        width = maxWidth;
                        height = height - (heightWidthRatio * widthDiff);
                    }

                    if (height > maxHeight) {
                        const heightDiff = height - maxHeight;
                        height = maxHeight;

                        width = width - (widthHeightRatio * heightDiff);
                    }

                    return {width: width, height: height};
                }
            };

            /* custom events */
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    lightbox.init(options.lightboxSetup);
                    view.init(options);
                }
            };


        })();


    });
